'use client';
var COMPONENT_ID = "TextField";
var defaultProps = {
    type: "text",
    size: "md1"
};

export { COMPONENT_ID, defaultProps };
